import React, { useEffect, useRef, useState } from "react";
import {
  CardProduct,
  CardProductName,
  ProductInfo,
  Row,
  Price,
  Icons,
  StyledInfinityScroll,
  Subtitle,
  IconContainer,
  AdminHeaderContainer,
  ClickContainer,
  HeaderWrapper,
  MainContainer,
  Content,
  CardProductImage,
  NumOfProducts,
  NumOfProductsTotal,
  NumOfProductsContainer,
  ContentWithFilters,
  CategoriesRow,
} from "./MarketplacePage.styles";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AdminHeader from "../../../components/AdminHeader/AdminHeader";
import UseAnimations from "react-useanimations";
import trash2 from "react-useanimations/lib/trash2";
import heart from "react-useanimations/lib/heart";
import {
  categoriesData,
  categoriesLoading,
  resetAddItem,
  resetEditItemData,
  resetSelectedItem,
  toggleFavoriteItem,
} from "../../../store/slices/marketplace/marketplaceSlice";
import { deleteMarketplaceItemLoader } from "../../../store/slices/marketplace/marketplaceSlice.js";
import { selectBusinessUserInfo } from "../../../store/slices/businessUser/slice";
import { checkPermission, priceFormatter } from "../../../utils/utils";
import ModalConfirm from "../../../components/ModalConfirm/ModalConfirm";
import { toast } from "react-toastify";
import { ReactComponent as Edit } from "../../../assets/icons/edit-3.svg";
import { ReactComponent as Share } from "../../../assets/icons/share-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../components/NewHeader/NewHeader";
import Footer from "../../../components/Footer.js";
import {
  bannerPhotos,
  businessUserRoleAction,
  getCurrencySymbol,
} from "../../../utils/constants";
import LoginModal from "../../../components/Modal/LoginModal.js";

import {
  useFavoriteItemMutation,
  useGetMarketplaceItemsQuery,
} from "../../../store/slices/marketplace/marketplaceApi.js";
import { api } from "../../../store/api/index.js";
import store from "../../../store/index.js";
import SkeletonMarketplaceLoader from "../../../components/SkeletonLoader/SkeletonMarketplaceLoader/SkeletonMarketplaceLoader.js";
import {
  removeItem,
  setPriorityMarketplaceItem,
} from "../../../store/slices/marketplace/asyncThunks.js";
import openToast from "../../../utils/toast.js";
import {
  selectedLocale,
  selectSidebarOpen,
} from "../../../store/slices/common/slice.js";
import { useSwipeable } from "react-swipeable";
import MediaBannerSlider from "../../../components/MediaSlider/MediaBannerSlider.js";
import SearchComponent from "../../LandingPage/SearchComponent.js";
import Checkbox from "../../../components/Checkbox/Checkbox.js";
import {
  Filter,
  FilterLabel,
  FilterRow,
  FiltersContainer,
  FilterSubtitle,
  FilterTitle,
  FilterTitleContainer,
  FilterWrapper,
} from "../utils/Sidebar.style.js";
import SkeletonMarketplaceSortLoader from "../../../components/SkeletonLoader/SkeletonMarketplaceSortLoader/SkeletonMarketplaceSortLoader.js";
import NavDropdown from "../../../components/CategoryDropdown/CategoryDropdown.js";

function ProductCard({
  product,
  itemDetails,
  removeItem,
  modal,
  setItems,
  reverse,
  items,
  draggedItemIndex,
  setDraggedItemIndex,
  index,

  draggable,
}) {
  const businessUser = useSelector(selectBusinessUserInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productId = product.id;
  const [favoriteItem] = useFavoriteItemMutation();
  const { t } = useTranslation();
  const toastId = useRef(null);
  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("category");

  const handleOnClickEdit = () => {
    const dataToSend = {
      productId: productId,
      action: "edit",
    };
    navigate(`/admin-portal/marketplace/add-an-item/${dataToSend.action}`, {
      state: dataToSend,
    });
  };

  const onShare = (id) => {
    const link = businessUser.loggedIn
      ? `${window.location.origin}/admin-portal/marketplace/item-detail/${id}`
      : `${window.location.origin}/marketplace/${id}`;

    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast.success(t("link-copied-to-clipboard"));
      })
      .catch((error) => {
        openToast(
          toastId,
          "share-marketplace-item",
          "error",
          t("Failed to copy link"),
        );
        console.error("Error copying link to clipboard:", error);
      });
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setActiveIndex((prevIndex) =>
        prevIndex === product?.photos.length - 1 ? 0 : prevIndex + 1,
      );
    },
    onSwipedRight: () => {
      setActiveIndex((prevIndex) =>
        prevIndex === 0 ? product?.photos.length - 1 : prevIndex - 1,
      );
    },
  });

  const handleDragStart = (e, index) => {
    if (
      !checkPermission(businessUser, businessUserRoleAction.post_item_priority)
    )
      return;
    setDraggedItemIndex(index);
    e.dataTransfer.effectAllowed = "move";
    // Postavi dataTransfer za vizuelni feedback
    e.dataTransfer.setData("text/plain", index);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedItemIndex === null || draggedItemIndex === dropIndex) return;
    if (
      !checkPermission(businessUser, businessUserRoleAction.post_item_priority)
    )
      return;

    const updatedItems = items.map((item) => ({ ...item }));

    // Ukloni dragovani item
    const [draggedItem] = updatedItems.splice(draggedItemIndex, 1);

    // Ubaci dragovani na novo mesto
    updatedItems.splice(dropIndex, 0, draggedItem);

    // Uzmi priority od itema koji je bio na drop poziciji pre promene
    const dropItemPriority =
      updatedItems[dropIndex - 1]?.priority !== undefined
        ? updatedItems[dropIndex - 1].priority + 1
        : 1;

    updatedItems[dropIndex] = {
      ...updatedItems[dropIndex],
      priority: dropItemPriority,
    };

    for (let i = dropIndex + 1; i < updatedItems.length; i++) {
      updatedItems[i] = {
        ...updatedItems[i],
        priority: updatedItems[i]?.priority + 1,
      };
    }

    // Update state
    setItems(updatedItems);
    setDraggedItemIndex(null);

    // Pošalji na backend
    dispatch(
      setPriorityMarketplaceItem({
        id: draggedItem.id,
        priority: dropItemPriority,
      }),
    )
      .unwrap()
      .then(() => {
        const entries = api.util.selectInvalidatedBy(store.getState(), [
          "marketplaceItems",
        ]);
        for (const { originalArgs } of entries) {
          const entryCategory = String(originalArgs?.category ?? "");

          if (entryCategory !== category) continue;

          dispatch(
            api.util.updateQueryData(
              "getMarketplaceItems",
              originalArgs,
              (draft) => {
                if (!draft?.data) return;

                draft.data = updatedItems.map((item) => ({ ...item }));
              },
            ),
          );
        }
      })
      .catch((err) => {
        console.log(err.message);
        openToast(toastId, "marketplace-item", t(err?.data?.message));
      });
  };

  return (
    <CardProduct
      {...handlers}
      $imageUrl={product?.photos[activeIndex]?.url}
      draggable={draggable}
      onDragStart={(e) => handleDragStart(e, index)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => handleDrop(e, index)}
      style={{
        opacity: draggedItemIndex === index ? 0.5 : 1,
        cursor: draggable ? "grab" : "default",
        border:
          draggedItemIndex !== null && draggedItemIndex !== index
            ? "2px dashed #ccc"
            : "none",
      }}
    >
      <CardProductImage
        $imageUrl={product?.photos[activeIndex]?.url}
        $loaded={true}
      />

      <Icons>
        {checkPermission(businessUser, businessUserRoleAction.delete_item) && (
          <IconContainer onClick={() => removeItem(product.id)}>
            <UseAnimations
              animation={trash2}
              size={32}
              wrapperStyle={{ marginTop: -4 }}
              strokeColor="#484888"
            />
          </IconContainer>
        )}
        {checkPermission(businessUser, businessUserRoleAction.put_item) && (
          <IconContainer onClick={handleOnClickEdit}>
            <Edit width={25} height={27} />
          </IconContainer>
        )}

        <IconContainer onClick={() => onShare(productId)}>
          <Share height={24} width={24} style={{ marginTop: -2 }} />
        </IconContainer>
        <IconContainer
          onClick={
            !businessUser?.loggedIn
              ? modal
              : () => {
                  dispatch(
                    toggleFavoriteItem({
                      id: productId,
                      like: !reverse,
                      businessUserId: businessUser.id,
                    }),
                  );
                  favoriteItem({ id: productId })
                    .unwrap()
                    .then(() => {})
                    .catch((err) => {
                      openToast(
                        toastId,
                        "marketplace-fav-item",
                        t(err?.data?.message),
                      );
                    });
                }
          }
        >
          <UseAnimations
            animation={heart}
            fillColor={businessUser?.loggedIn ? "#484888" : "transparent"}
            strokeColor="#484888"
            reverse={reverse}
            size={32}
          />
        </IconContainer>
      </Icons>

      <ClickContainer onClick={itemDetails} />
      <ProductInfo>
        <CardProductName
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ar && product?.nameAr ? product?.nameAr : product?.name}
        </CardProductName>
        <Row>
          <Price>
            {priceFormatter(product?.price ?? product?.samplePrice, true, 15)}{" "}
            {getCurrencySymbol(product?.currency)}
          </Price>
          {product?.minQuantity && (
            <Price>
              Min Qty:{" "}
              <Price style={{ fontWeight: 800 }}>{product?.minQuantity}</Price>
            </Price>
          )}
        </Row>
      </ProductInfo>
    </CardProduct>
  );
}

const MarketplacePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { loggedIn } = useSelector(selectBusinessUserInfo);
  const businessUser = useSelector(selectBusinessUserInfo);

  const deletePending = useSelector(deleteMarketplaceItemLoader);
  const [selectedItem, setSelectedItem] = useState(null);
  const [areYouSureModal, setAreYouSureModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("category");
  const [activeIndexBanner, setActiveIndexBanner] = useState(0);

  const categories = useSelector(categoriesData);
  const categoriesPending = useSelector(categoriesLoading);
  const selectedId = queryParams.get("category");

  const [queryData, setQueryData] = useState({
    page: 1,
    category: category || "",
  });

  const priceFromParam = queryParams.get("priceFrom");
  const priceToParam = queryParams.get("priceTo");

  const priceFilters = [
    { id: 1, priceFrom: 0, priceTo: 100 },
    { id: 2, priceFrom: 101, priceTo: 300 },
    { id: 3, priceFrom: 301, priceTo: 500 },
    { id: 4, priceFrom: 500 },
  ];

  useEffect(() => {
    if (location.pathname === "/ops-portal/marketplace") {
      if (category && category !== null) {
        navigate(`/ops-portal/marketplace?category=${category}`);
      } else {
        navigate(`/ops-portal/marketplace`);
      }
    } else {
      if (loggedIn) {
        if (location.pathname !== `/admin-portal/marketplace`) {
          navigate(`/admin-portal/marketplace?${location.search}`);
        }
      } else {
        if (location.pathname !== `/marketplace`) {
          navigate(`/marketplace?${location.search}`);
        }
      }
    }

    if (category !== queryData.category) {
      setQueryData({ page: 1, category: category || "" });
    }
  }, [loggedIn, navigate, category]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has("category")) return;

    if (!categories || categories.length === 0) return;

    const firstCategory = categories[0];

    const firstId =
      firstCategory.subcategories?.length > 0
        ? firstCategory.subcategories[0].id
        : firstCategory.id;

    params.set("category", firstId);

    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true,
    });
  }, [categories, location.pathname, location.search, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const newQueryData = {
      page: 1,
      category: params.get("category") || "",
      priceFrom: params.get("priceFrom")
        ? parseInt(params.get("priceFrom"))
        : undefined,
      priceTo: params.get("priceTo")
        ? parseInt(params.get("priceTo"))
        : undefined,
    };

    setQueryData(newQueryData);
  }, [location.search]);

  useEffect(() => {
    dispatch(resetAddItem());
  }, [dispatch]);

  const { data, isFetching, originalArgs } =
    useGetMarketplaceItemsQuery(queryData);

  const loadMoreItems = () => {
    if (!data?.maxReached && !isFetching) {
      setQueryData((prev) => {
        const page = originalArgs?.page + 1 ?? queryData.page + 1;
        return { ...prev, page };
      });
    }
  };

  const removeItemOpenModal = (id) => {
    setAreYouSureModal(true);
    setSelectedItem(id);
  };
  const removeItemAction = () => {
    dispatch(removeItem(selectedItem))
      .unwrap()
      .then(() => {
        setAreYouSureModal(false);

        toast.success(t("item-deleted"));

        const entries = api.util.selectInvalidatedBy(store.getState(), [
          "marketplaceItems",
        ]);
        for (const { originalArgs } of entries) {
          dispatch(
            api.endpoints.getMarketplaceItems.initiate(originalArgs, {
              subscribe: false,
              forceRefetch: true,
            }),
          );
        }
      })
      .catch((err) => {
        toast.error(t(err.message));
      });
  };

  const handleItemClick = (itemId) => {
    dispatch(resetSelectedItem());
    dispatch(resetEditItemData());
    window.scrollTo(0, 0);
    if (location.pathname === "/ops-portal/marketplace") {
      navigate(
        `/ops-portal/marketplace/item-detail/${itemId}?category=${
          category ?? ""
        }`,
      );
    } else {
      if (loggedIn) {
        navigate(
          `/admin-portal/marketplace/item-detail/${itemId}?category=${
            category ?? ""
          }`,
        );
      } else {
        navigate(`/marketplace/${itemId}?category=${category ?? ""}`);
      }
    }
  };

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const [headerVisible, setHeaderVisible] = useState(true);
  const [lastScrollUpY, setLastScrollUpY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);
  const lastScrollTopRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      const lastScrollTop = lastScrollTopRef.current;

      if (currentScrollTop === 0) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
        setScrollDirection(null);
        lastScrollTopRef.current = currentScrollTop;
        return;
      }

      if (currentScrollTop > lastScrollTop) {
        setScrollDirection("down");
        setLastScrollUpY(currentScrollTop);
      } else {
        setScrollDirection("up");
      }

      if (scrollDirection === "up" && currentScrollTop < lastScrollUpY - 350) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
      }

      if (
        scrollDirection === "down" &&
        currentScrollTop > lastScrollUpY + 350
      ) {
        setHeaderVisible(false);
      }

      lastScrollTopRef.current = currentScrollTop;
    };

    const handleScrollDebounced = () => {
      requestAnimationFrame(handleScroll);
    };

    window.addEventListener("scroll", handleScrollDebounced);

    return () => {
      window.removeEventListener("scroll", handleScrollDebounced);
    };
  }, [scrollDirection]);

  const opened = useSelector(selectSidebarOpen);

  const [items, setItems] = useState([]);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);

  useEffect(() => {
    if (data?.data) {
      setItems(data.data);
    }
  }, [data]);

  const handleChecked = (filter) => {
    let checked = false;
    if (
      filter.priceFrom === parseInt(priceFromParam) &&
      filter.priceTo === parseInt(priceToParam)
    ) {
      checked = true;
    } else if (
      (!filter.priceFrom && filter.priceTo === parseInt(priceToParam)) ||
      (filter.priceFrom === parseInt(priceFromParam) && !filter.priceTo)
    ) {
      checked = true;
    }
    return checked;
  };

  return (
    <>
      <MainContainer $column>
        <HeaderWrapper
          style={{
            opacity: headerVisible ? 1 : 0,
            marginTop: headerVisible ? 0 : -150,
            transition: "all 0.3s ease-in-out",
          }}
        >
          <Header />
        </HeaderWrapper>

        <Content $ar={ar} $loggedIn $open={opened}>
          <CategoriesRow
            style={{ paddingBottom: categoriesPending ? 0 : 12 }}
            data-categories-row
          >
            {/* {categoriesPending ? (
            <LoaderContainer>
              <SkeletonMarketplaceSortLoader single />
            </LoaderContainer>
          ) : (
            <Category
              $active={!selectedId && location.pathname.includes("marketplace")}
              onClick={() => {
                window.scrollTo(0, 0);
                if (selectedId !== "") {
                  if (loggedIn) {
                    if (location.pathname.includes("ops-portal")) {
                      navigate(`/ops-portal/marketplace`);
                    } else {
                      navigate(`/admin-portal/marketplace`);
                    }
                  } else {
                    navigate(`/marketplace`);
                  }
                }
              }}
            >
              {t("all")}
            </Category>
          )} */}
            {categoriesPending ? (
              <CategoriesRow style={{ marginBottom: 0 }}>
                <SkeletonMarketplaceSortLoader marketplace />
              </CategoriesRow>
            ) : (
              categories?.map((category) => (
                <NavDropdown
                  key={category.id}
                  label={
                    ar
                      ? t(category.nameAr ? category.nameAr : category.name)
                      : t(category.name)
                  }
                  items={category.subcategories}
                  selectedId={selectedId}
                  red={category.name === "sale"}
                  category={category}
                  ar={ar}
                  onClickCategory={() => {
                    window.scrollTo(0, 0);
                    if (!category?.subcategories?.length) {
                      if (loggedIn) {
                        if (
                          location.pathname.includes("ops-portal") &&
                          location.pathname !==
                            `/ops-portal/marketplace?category=${category.id}`
                        ) {
                          navigate(
                            `/ops-portal/marketplace?category=${category.id}`,
                          );
                        } else {
                          if (
                            location.pathname !==
                            `/admin-portal/marketplace?category=${category.id}`
                          ) {
                            navigate(
                              `/admin-portal/marketplace?category=${category.id}`,
                            );
                          }
                        }
                      } else {
                        if (
                          location.pathname !==
                          `/marketplace?category=${category.id}`
                        ) {
                          navigate(`/marketplace?category=${category.id}`);
                        }
                      }
                    }
                  }}
                  onSelect={(item) => {
                    window.scrollTo(0, 0);

                    if (loggedIn) {
                      if (location.pathname.includes("ops-portal")) {
                        navigate(`/ops-portal/marketplace?category=${item.id}`);
                      } else {
                        navigate(
                          `/admin-portal/marketplace?category=${item.id}`,
                        );
                      }
                    } else {
                      navigate(`/marketplace?category=${item.id}`);
                    }
                  }}
                />
                // <Category
                //   $red={category.name === "sale"}
                //   key={category.id}
                //   $active={
                //     category.id === parseInt(selectedId) &&
                //     location.pathname.includes("marketplace")
                //   }
                //   onClick={() => {
                //     console.log("totjajajajaja");

                //     window.scrollTo(0, 0);
                //     if (loggedIn) {
                //       if (
                //         location.pathname.includes("ops-portal") &&
                //         location.pathname !==
                //           `/ops-portal/marketplace?category=${category.id}`
                //       ) {
                //         navigate(
                //           `/ops-portal/marketplace?category=${category.id}`,
                //         );
                //       } else {
                //         if (
                //           location.pathname !==
                //           `/admin-portal/marketplace?category=${category.id}`
                //         ) {
                //           navigate(
                //             `/admin-portal/marketplace?category=${category.id}`,
                //           );
                //         }
                //       }
                //     } else {
                //       if (
                //         location.pathname !==
                //         `/marketplace?category=${category.id}`
                //       ) {
                //         navigate(`/marketplace?category=${category.id}`);
                //       }
                //     }
                //   }}
                // >
                //   {ar
                //     ? t(category.nameAr ? category.nameAr : category.name)
                //     : t(category.name)}
                // </Category>
              ))
            )}
          </CategoriesRow>

          <MediaBannerSlider
            timer={10000}
            activeIndex={activeIndexBanner}
            setActiveIndex={setActiveIndexBanner}
            images={bannerPhotos}
            ar={ar}
            total={bannerPhotos?.length}
          />
          <SearchComponent marginOff />

          {loggedIn && (
            <AdminHeaderContainer>
              <AdminHeader showButtons hideSearch hideSendGifts />
            </AdminHeaderContainer>
          )}

          {items?.length > 0 && !isFetching && (
            <NumOfProductsContainer>
              <NumOfProducts>{t("showing")}</NumOfProducts>
              <NumOfProductsTotal>{data?.total}</NumOfProductsTotal>
              <NumOfProducts>{t("products")}</NumOfProducts>
            </NumOfProductsContainer>
          )}

          {isFetching && queryData.page === 1 ? (
            <SkeletonMarketplaceLoader />
          ) : (
            <>
              <ContentWithFilters>
                <FiltersContainer $open={headerVisible}>
                  <FilterWrapper>
                    <FilterTitleContainer>
                      {/* <FilterIcon /> */}
                      <FilterTitle>{t("filters")}</FilterTitle>
                      <FilterSubtitle>{t("price-range")}</FilterSubtitle>
                    </FilterTitleContainer>

                    {priceFilters.map((filter, i) => {
                      return (
                        <Filter
                          key={i}
                          onClick={() => {
                            if (
                              (filter.priceFrom === parseInt(priceFromParam) &&
                                filter.priceTo === parseInt(priceToParam)) ||
                              filter.priceFrom === parseInt(priceFromParam)
                            ) {
                              let path = location.pathname;
                              if (category && category !== null) {
                                path += `?category=${category}`;
                              }
                              navigate(path);
                            } else {
                              let path = location.pathname;
                              let query = "?";
                              if (category && category !== null) {
                                path += `?category=${category}`;
                                query = "&";
                              }

                              if (filter.priceFrom || filter.priceFrom === 0) {
                                path += query + `priceFrom=${filter.priceFrom}`;
                                query = "&";
                              }
                              if (filter.priceTo) {
                                path += query + `priceTo=${filter.priceTo}`;
                              }
                              navigate(path);
                            }
                          }}
                        >
                          <Checkbox checked={handleChecked(filter)} size={20} />
                          {filter.priceTo ? (
                            filter.priceFrom === 0 ? (
                              <FilterLabel>
                                {`Under ${priceFormatter(
                                  filter.priceTo,
                                  false,
                                  0,
                                )} SR`}
                              </FilterLabel>
                            ) : (
                              <FilterRow>
                                <FilterLabel>
                                  {priceFormatter(filter.priceFrom, false, 0)}
                                </FilterLabel>
                                <FilterLabel>SR</FilterLabel>
                                <FilterLabel>-</FilterLabel>
                                <FilterLabel>
                                  {priceFormatter(filter.priceTo, false, 0)}
                                </FilterLabel>
                                <FilterLabel>SR</FilterLabel>
                              </FilterRow>
                            )
                          ) : (
                            <FilterLabel>
                              {`Above ${priceFormatter(
                                filter.priceFrom,
                                false,
                                0,
                              )} SR`}
                            </FilterLabel>
                          )}
                        </Filter>
                      );
                    })}
                  </FilterWrapper>
                </FiltersContainer>

                {data?.data?.length > 0 ? (
                  <StyledInfinityScroll
                    dataLength={items?.length ?? 0}
                    hasMore={!data?.maxReached}
                    next={loadMoreItems}
                    loader={<SkeletonMarketplaceLoader single />}
                  >
                    {items?.map((product, index) => (
                      <ProductCard
                        key={product.id}
                        index={index}
                        draggedItemIndex={draggedItemIndex}
                        setDraggedItemIndex={setDraggedItemIndex}
                        reverse={product.favorite}
                        itemDetails={() => handleItemClick(product.id)}
                        product={product}
                        modal={() => setLoginModal(true)}
                        removeItem={removeItemOpenModal}
                        items={items}
                        setItems={setItems}
                        draggable={checkPermission(
                          businessUser,
                          businessUserRoleAction.post_item_priority,
                        )}
                      />
                    ))}
                  </StyledInfinityScroll>
                ) : (
                  <Subtitle>{t("category-is-empty")}</Subtitle>
                )}
              </ContentWithFilters>
            </>
          )}
        </Content>
        <Footer ar={ar} />
      </MainContainer>

      <LoginModal open={loginModal} close={() => setLoginModal(false)} />
      <ModalConfirm
        open={areYouSureModal}
        close={() => {
          setAreYouSureModal(false);
        }}
        onClickNo={() => {
          setAreYouSureModal(false);
        }}
        onClickYes={() => {
          removeItemAction();
        }}
        confirmLoading={deletePending}
      />
    </>
  );
};

export default MarketplacePage;
